module.exports = __webpack_public_path__ + "static/media/exukonline-how-to-buy-detail-page.c6e34ad7.png";